import {post} from '@/api'
import {getAllRoutes} from "@/utils/router.js"

const moduleUser={
    state: {
        username:'',
        token:'',
        myroutes:[] 
    },
    mutations: {
        SET_USERNAME:(state,payload)=>{
            state.username=payload.username
        },
        SET_TOKEN:(state,payload)=>{
            state.token=payload.token
        },
        LOG_OUT:(state)=>{
            state.username=''
            state.token=''
            state.myroutes=[]
        },
        INIT_POWERLIST:(state)=>{
            state.myroutes=getAllRoutes() 
        }
    },
    actions: {
        doLogin({commit},data){
            return new Promise((resolve)=>{
                post("/login/doLogin",{username:data.username,password:data.password}).then((data)=>{
                    if(data.result.success){
                        commit("SET_USERNAME",{username:data.result.info.username})
                        commit("SET_TOKEN",{token:data.result.info.token})
                        commit("INIT_POWERLIST",{issuper:data.result.info.issuper,powerlist:data.result.info.powerlist})
                    }
                    resolve(data)
                }).catch(()=>{});
            }).catch(()=>{})
        },
        doLogout({commit}){
            return new Promise((resolve)=>{
                post("/login/doLogout",{}).then((data)=>{
                    if(data.result.success){
                        commit("LOG_OUT")
                    }
                    resolve(data)
                }).catch(()=>{});
            }).catch(()=>{})
        }
    }
}

export default moduleUser